<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="projectName"
          size="small"
          @keydown.enter.native="search"
          @clear="search"
          placeholder="请输入项目名称进行搜索..."
          clearable
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          size="small"
          >搜索</el-button
        >

        <!-- 税金日期区间筛选（与其它项目管理页面保持一致） -->
        <el-date-picker
          v-model="rqScope"
          style="margin-left: 10px"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="onDateChange"
        >
        </el-date-picker>
        <!-- <el-button type="primary" disabled="true" size="small"> <i class="fa fa-angle-double-down" aria-hidden="true"></i>
					高级搜索</el-button> -->
      </div>
      <!-- 右边工具 -->
      <div>
        <!-- <el-button type="success" disabled="true" size="small"> <i class="fa fa-level-up" aria-hidden="true"></i> 导入数据
				</el-button>
				<el-button type="success" disabled="true" size="small"> <i class="fa fa-level-down" aria-hidden="true"></i> 导出数据
				</el-button> -->
        <el-button type="success" @click="downloadExcel" size="small">
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加税金</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <!-- :key 绑定筛选值：Element 的表头插槽在父组件数据变化时不会重新求值，
           导致表头里的 el-select 拿不到新值、选中后不回显。改变 key 强制整表重建即可。 -->
      <el-table
        :data="rateData"
        :key="'rateTable-' + queryRateCode"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <!-- 本表已去掉全部固定列（fixed）。
             原因：Element 会把「整行表头」克隆进固定层再裁切，导致表头里的筛选控件在 DOM 里
             出现 3 份、选中值不回显。业务确认横向滚动时不需要钉住这几列，故全部去掉。 -->
        <el-table-column
          prop="bm"
          label="项目编码"
          align="center"
          width="130"
        >
        </el-table-column>
        <!-- <el-table-column prop="projectId" label="项目ID" sortable fixed align="center" width="90">
				</el-table-column> -->
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="rq"
          label="税金日期"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <!-- 税种名称：筛选放在表头（参照商机管理）。列不写 label，列名由 placeholder 承担 -->
        <el-table-column
          prop="rateName"
          align="center"
          width="135"
        >
          <template slot="header">
            <el-select
              v-model="queryRateCode"
              size="mini"
              placeholder="税种名称"
              style="width: 100%"
              filterable
              clearable
              @change="search"
            >
              <el-option
                v-for="item in rates"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="税金金额" sortable align="center" width="130" :sort-method="(a, b) => a.rate - b.rate">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.rate) }}</span>
            <!-- <span v-if="scope.row.rate<10000">{{scope.row.rate}}</span> <span style="font-size: 10px"
							v-if="scope.row.rate<10000">元</span>
						<el-tag v-if="scope.row.rate>=10000">{{scope.row.rate/10000}}</el-tag> <span
							style="font-size: 10px" v-if="scope.row.rate>=10000">万元</span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          label="创建日期"
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          sortable
          label="修改日期"
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="175"
          v-if="qx"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
        "
      >
        <div>税金金额合计（当前页）: {{ moneyNumber(rateTotal) }}</div>
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page"
          :page-size="limit"
          :page-sizes="[10, 20, 50, 100, 200]"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectId">
                <!--  filterable -->
                <el-select
                  v-model="inputObj.projectId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="税金日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="税种名称" prop="rateCode">
                <el-select
                  v-model="inputObj.rateCode"
                  placeholder="请选择"
                  size="mini"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in rates"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="  税金金额" prop="rate">
                <el-input
                  type="number"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.rate"
                  placeholder="请输入金额,单位(元)"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import { kz } from "../../utils/MyFunction";

export default {
  name: "ProjRate",
  data() {
    return {
      qx: true,
      title: "",
      xmShow: false,
      rateData: [], // 存放查询结果
      loading: false,
      total: 0,
      rateTotal: 0, // 税金金额合计（仅统计当前页返回的数据）
      page: 1,
      limit: 50,
      projectName: "",
      rqScope: [], // 税金日期区间（绑定日期控件，提交时拆成 rqBegin/rqEnd）
      queryRqBegin: "", // 查询用：税金日期起
      queryRqEnd: "", // 查询用：税金日期止
      queryRateCode: "", // 查询用：税种代码（表头筛选）
      dialogVisible: false,
      // 新增税金对象
      inputObj: {
        id: null,
        projectId: null,
        rq: "",
        rateCode: "",
        rate: null,
      },
      projects: [], //项目id-项目名称下拉框
      rates: [], // 税种 下拉框
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "blur",
          },
        ],
        rq: [
          {
            required: true,
            message: "请选择税金日期",
            trigger: "blur",
          },
        ],
        rateCode: [
          {
            required: true,
            message: "请选择税种代码",
            trigger: "blur",
          },
        ],
        rate: [
          {
            required: true,
            message: "请输入税金金额",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.quanxian();
    this.initRate();
    this.initDim();
  },
  methods: {
    moneyNumber(val) {
      // 与"借款管理"统计保持一致：全角￥ + 数字（无千分位，最多 2 位小数）
      return "￥" + Number(Number(val || 0).toFixed(2));
    },
    // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 列表查询与导出共用同一套筛选参数，避免两处拼参不一致
    buildRateUrl(page, limit) {
      let url =
        "/project/rate_list?page=" +
        page +
        "&limit=" +
        limit +
        "&projectName=" +
        encodeURIComponent(this.projectName);
      // 税金日期区间
      if (this.queryRqBegin) url += "&rqBegin=" + this.queryRqBegin;
      if (this.queryRqEnd) url += "&rqEnd=" + this.queryRqEnd;
      // 税种名称（按税种代码精确筛选）
      if (this.queryRateCode) url += "&rateCode=" + this.queryRateCode;
      return url;
    },
    // 导出列定义：页面表格列去掉"操作"列与创建日期/修改日期（业务确认导出不需要时间列）
    // 注意：页面表格仍保留创建/修改日期列，仅导出不含；不要顺手加回来。
    getExportColumns() {
      return [
        { header: "项目编码", key: "bm", width: 18 },
        { header: "项目名称", key: "projectName", width: 36, align: "left" },
        { header: "税金日期", key: "rq", width: 14 },
        { header: "税种名称", key: "rateName", width: 16 },
        { header: "税金金额", key: "rate", width: 15, money: true },
      ];
    },
    // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "项目税金录入_20260212.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    async exportRowsToExcel(rows, fileName, sheetName) {
      const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS =
        mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const columns = this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 columns.header 自动生成）
      sheet.columns = columns.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

      // 表头样式：加粗 + 灰底 + 居中 + 边框
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEEF1F6" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行：滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = columns.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        columns.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.align || "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 导出入口：按当前筛选条件拉全量数据后直接生成 Excel（不渲染表格，无需还原分页状态）
    downloadExcel() {
      const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
      const fileName = "项目税金录入_" + this.exportFileDate() + ".xlsx";
      this.loading = true;
      this.getRequest(this.buildRateUrl(1, EXPORT_LIMIT))
        .then((resp) => {
          this.loading = false;
          const rows = (resp && resp.data) || [];
          if (!rows.length) {
            this.$message({
              type: "warning",
              message: "当前筛选条件下没有数据",
            });
            return;
          }
          return this.exportRowsToExcel(rows, fileName).catch((e) => {
            console.log(e);
            this.$message({ type: "error", message: "导出失败，请重试" });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
        // 销售(角色id 2)只读：隐藏"添加"按钮与整个操作列
        if (this.doesItContain([2]).length > 0) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz(sj);
      return sf;
    },
    doChance() {
      this.dialogVisible = false;
      this.initRate();
    },
    showEditView(data) {
      this.title = "编辑税金";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " + data.projectName + "的该条税金明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/project/rate_delete?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initRate();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/rate_update", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initRate();
                }
              }
            );
          }
        });
      } else {
        // 添加
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/project/rate_add", this.inputObj).then(
              (resp) => {
                if (resp) {
                  this.dialogVisible = false;
                  this.initRate();
                }
              }
            );
          }
        });
      }
      // this.dialogVisible = false
    },
    initDim() {
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.projects = this.dictCache("projects");
      }
      if (!window.sessionStorage.getItem("rates")) {
        this.postRequest("/dim/dim_table_char/rate_code").then((resp) => {
          if (resp) {
            this.rates = resp.result;
            this.saveDictCache("rates", resp.result);
          }
        });
      } else {
        this.rates = this.dictCache("rates");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initRate();
    },
    sizeChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.initRate();
    },
    // 条件查询：回到第 1 页再查，避免停留在超出结果范围的页码上
    search() {
      this.page = 1;
      this.initRate();
    },
    // 税金日期区间变化：拆成起止日期后查询
    onDateChange(val) {
      if (val && val.length === 2) {
        this.queryRqBegin = val[0];
        this.queryRqEnd = val[1];
      } else {
        this.queryRqBegin = "";
        this.queryRqEnd = "";
      }
      this.search();
    },
    showAddView() {
      this.title = "添加税金";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        projectId: null,
        rq: "",
        rateCode: "",
        rate: null,
      };
    },
    initRate() {
      this.loading = true;
      const url = this.buildRateUrl(this.page, this.limit);
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          this.rateData = resp.data;
          this.total = resp.count;
          // 合计（当前页）：只累加本次返回的数据，翻页/改每页条数/筛选后重新计算
          this.rateTotal = 0;
          (resp.data || []).forEach((item) => {
            this.rateTotal = Number(
              (this.rateTotal + Number(item.rate || 0)).toFixed(2)
            );
          });
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.removeItem("projects");
    next();
  },
};
</script>

<style>
</style>
